module.exports = __webpack_public_path__ + "static/media/loan.b4bb01df.svg";